export const SET_GUARD_PANEL_ADDRESS = '@@guardPanel/setGuardPanelAddress'
export const ACTIVATE_IN_PROGRESS_ALARM = '@@guardPanel/activateInProgressAlarm'
export const DEACTIVATE_IN_PROGRESS_ALARM = '@@guardPanel/deactivateInProgressAlarm'
